import script from "./suppliers.vue?vue&type=script&setup=true&lang=ts"
export * from "./suppliers.vue?vue&type=script&setup=true&lang=ts"

import "./suppliers.vue?vue&type=style&index=0&id=074fe32e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074fe32e"]])

export default __exports__